export default __webpack_public_path__ + "img/uploadV2black.bdc46805.svg";